.spinner {
  display: inline-block;
  border: 2px solid;
  border-radius: 100%;
  background: transparent;
  animation: spin 0.75s linear infinite both;
}

@keyframes spin {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(0.8);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}
